(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["r1-machine-finder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-r1-brand-filter]').forEach((filter) => {
    if (filter.dataset.ready === 'true') return;
    filter.dataset.ready = 'true';
    const finder = filter.closest('.r1-finder');
    const select = filter.querySelector('[data-r1-brand-select]');
    const buttons = filter.querySelectorAll('[data-r1-brand-button]');
    const groups = finder.querySelectorAll('[data-r1-brand-group]');
    const status = filter.querySelector('[data-r1-filter-status]');
    const applyFilter = (brand) => {
      groups.forEach((group) => { group.hidden = brand !== 'all' && group.dataset.r1BrandGroup !== brand; });
      buttons.forEach((button) => {
        const active = button.dataset.r1BrandButton === brand;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (select) select.value = brand;
      const chosen = select ? select.options[select.selectedIndex].text : 'All brands';
      if (status) status.textContent = brand === 'all' ? 'Showing all brands' : `Showing ${chosen} models`;
    };
    if (select) select.addEventListener('change', () => applyFilter(select.value));
    buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.r1BrandButton)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["r1-polaris-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-r1-polaris-hub]').forEach((hub) => {
    const modelSelect = hub.querySelector('[data-r1-model]');
    const yearSelect = hub.querySelector('[data-r1-year]');
    const submit = hub.querySelector('[data-r1-submit]');
    const status = hub.querySelector('[data-r1-status]');
    const scroller = hub.querySelector('[data-r1-machine-grid]');
    const previous = hub.querySelector('[data-r1-prev]');
    const next = hub.querySelector('[data-r1-next]');

    if (!modelSelect || !yearSelect || !submit) return;

    const renderYears = () => {
      const selected = modelSelect.options[modelSelect.selectedIndex];
      const years = selected?.dataset.years?.split('|').filter(Boolean) || [];
      yearSelect.replaceChildren(new Option(hub.dataset.yearAll, ''));
      years.forEach((year) => yearSelect.add(new Option(year, year)));
      yearSelect.disabled = !modelSelect.value;
      submit.disabled = !modelSelect.value;
      status.textContent = modelSelect.value ? `${hub.dataset.statusReady} ${selected.text}` : hub.dataset.statusChoose;
    };

    modelSelect.addEventListener('change', renderYears);
    yearSelect.addEventListener('change', () => {
      const model = modelSelect.options[modelSelect.selectedIndex]?.text || '';
      status.textContent = yearSelect.value ? `${hub.dataset.statusReady} ${yearSelect.value} ${model}` : `${hub.dataset.statusReady} ${model}`;
    });

    submit.addEventListener('click', () => {
      if (!modelSelect.value) return;
      const destination = yearSelect.value ? `${modelSelect.value}/${yearSelect.value}` : modelSelect.value;
      window.location.assign(destination);
    });

    const scrollMachines = (direction) => {
      if (!scroller) return;
      const firstCard = scroller.querySelector('.r1-ph__machine-card');
      const distance = firstCard ? firstCard.getBoundingClientRect().width + 14 : scroller.clientWidth * .82;
      scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => scrollMachines(-1));
    next?.addEventListener('click', () => scrollMachines(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["r1-polaris-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-r1-make-landing]').forEach((landing) => {
    const model = landing.querySelector('[data-r1-model]');
    const part = landing.querySelector('[data-r1-part]');
    const go = landing.querySelector('[data-r1-go]');
    const status = landing.querySelector('[data-r1-status]');
    const scroller = landing.querySelector('[data-r1-model-grid]');
    const manufacturer = landing.dataset.manufacturer || 'machine';

    if (!model || !go) return;

    const partTypesEnabled = landing.querySelector('.r1-pl__finder')?.dataset.partTypesEnabled === 'true';

    const partTypes = [
      ['windshields', 'Windshields'],
      ['roofs', 'Roofs'],
      ['doors', 'Doors & Enclosures'],
      ['bumpers', 'Bumpers'],
      ['mirrors', 'Mirrors'],
      ['lighting', 'Lighting'],
      ['storage', 'Storage'],
      ['skidPlates', 'Skid Plates'],
      ['clutchKits', 'Clutch Kits'],
      ['radiusRods', 'Radius Rods'],
      ['tieRods', 'Tie Rods'],
      ['driveBelts', 'Drive Belts']
    ];

    const rebuildParts = () => {
      const selected = model.options[model.selectedIndex];

      if (!model.value) {
        if (part) {
          part.replaceChildren();
          part.add(new Option('Select a model first', ''));
          part.disabled = true;
        }
        go.disabled = true;
        status.textContent = `Choose your ${manufacturer} model to begin.`;
        return;
      }

      if (!partTypesEnabled || !part) {
        go.disabled = false;
        status.textContent = `Ready to shop all parts for ${selected.text}.`;
        return;
      }

      part.replaceChildren();
      part.add(new Option('All parts for this model', model.value));
      partTypes.forEach(([key, label]) => {
        const url = selected.dataset[key];
        if (url) part.add(new Option(label, url));
      });
      part.disabled = false;
      go.disabled = false;
      status.textContent = `${part.options.length - 1} focused part types available for ${selected.text}.`;
    };

    model.addEventListener('change', rebuildParts);
    part?.addEventListener('change', () => {
      const modelName = model.options[model.selectedIndex]?.text || `your ${manufacturer}`;
      const partName = part.options[part.selectedIndex]?.text || 'parts';
      status.textContent = `Ready to shop ${partName.toLowerCase()} for ${modelName}.`;
      go.disabled = !part.value;
    });

    go.addEventListener('click', () => {
      const destination = partTypesEnabled && part ? part.value : model.value;
      if (destination) window.location.assign(destination);
    });

    landing.querySelector('[data-r1-prev]')?.addEventListener('click', () => {
      const card = scroller?.querySelector('.r1-pl__model-card');
      scroller?.scrollBy({ left: -(card?.getBoundingClientRect().width || 320) - 14, behavior: 'smooth' });
    });
    landing.querySelector('[data-r1-next]')?.addEventListener('click', () => {
      const card = scroller?.querySelector('.r1-pl__model-card');
      scroller?.scrollBy({ left: (card?.getBoundingClientRect().width || 320) + 14, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["r1-shop-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest && event.target.closest('a');
  if (!link) return;
  const page = link.closest('[data-repair-page]');
  if (!page || page.classList.contains('r1-sp--about')) return;
  const href = link.getAttribute('href') || '';
  let method = '';
  if (href.startsWith('tel:')) method = 'call';
  else if (href.startsWith('sms:')) method = 'text';
  else if (href.startsWith('https://www.google.com/maps/dir/')) method = 'directions';
  else if (href === '/pages/get-a-utv-repair-quote-r1' || href === '#r1-service-request') method = 'quote_form';
  if (!method) return;
  window.dataLayer = window.dataLayer || [];
  const sendEvent = typeof window.gtag === 'function' ? window.gtag : function() { window.dataLayer.push(arguments); };
  sendEvent('event', 'r1_repair_contact_click', {send_to:'G-SJC96T1RX4',contact_method:method,repair_page:page.dataset.repairPage,contact_placement:link.closest('.r1-sp__hero')?'hero':link.closest('.r1-sp__final')?'final':link.closest('.r1-sp__location')?'location':'content'});
});

  } catch(e) { console.error(e); }
})();
})();
